import React from 'react'
import { LocaleProvider } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'

export function ContextWrapper({ children }) {
  return <LocaleProvider locale={enUS}>{children}</LocaleProvider>
}
